import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import img from '../../../../assets/images/overlay-decorations-left.svg.js';
import img$1 from '../../../../assets/images/overlay-decorations-right.svg.js';
import img$2 from '../../../../assets/images/overlay-decorations-left-mobile.svg.js';
import img$3 from '../../../../assets/images/overlay-decorations-right-mobile.svg.js';
import css_248z from './full-image-video-banner.scss.js';

class FullImageVideoBanner extends s {
    constructor() {
        super(...arguments);
        this.backgroundType = 'image';
        this.backgroundVideoUrl = '#';
        this.backgroundImgUrl = '#';
        this.backgroundImgUrlMobile = '';
        this.backgroundImgAlt = '';
        this.imgUrl = '#';
        this.imgAlt = '';
        this.title = '';
        this.description = '';
        this.withBlackOverlay = true;
        this.withOverlayDecorations = true;
    }
    renderBackground() {
        const mobileDisplayNone = this.backgroundImgUrlMobile
            ? 'mobile-display-none'
            : '';
        const renderMobileBackground = () => this.backgroundImgUrlMobile
            ? $ `<img class="background-image desktop-display-none" src="${this.backgroundImgUrlMobile}" alt="${this.backgroundImgAlt}">`
            : null;
        if (this.backgroundType === 'image') {
            return $ `<img class="background-image ${mobileDisplayNone}" src="${this.backgroundImgUrl}" alt="${this.backgroundImgAlt}">${renderMobileBackground()}`;
        }
        if (this.backgroundType === 'video') {
            return $ `<slot name="background-video"></slot>`;
        }
        return $ `<img class="background-image-default" src="" alt="">`;
    }
    renderBlackOverlay() {
        return this.withBlackOverlay
            ? $ `<div class="back-overlay"></div>`
            : null;
    }
    renderOverlayDecorations() {
        return this.withOverlayDecorations
            ? $ `<div class="overlay-decorations"><img class="overlay-decorations-left" src="${img}" alt="overlay decoration left"> <img class="overlay-decorations-right" src="${img$1}" alt="overlay decoration right"> <img class="overlay-decorations-left-mobile" src="${img$2}" alt="overlay decoration left mobile"> <img class="overlay-decorations-right-mobile" src="${img$3}" alt="overlay decoration right mobile"></div>`
            : null;
    }
    renderContent() {
        if (!this.imgUrl && !this.title && !this.description)
            return null;
        const renderImg = () => this.imgUrl &&
            $ `<img class="logo-image" src="${this.imgUrl}" alt="${this.imgAlt || ''}">`;
        const renderTitle = () => this.title && $ `<h1 class="title">${o(this.title)}</h1>`;
        const renderDescription = () => this.description && $ `<p class="description">${o(this.description)}</p>`;
        return $ `<div class="content">${renderImg()} ${renderTitle()} ${renderDescription()}</div>`;
    }
    render() {
        return $ `<div class="full-image-video-banner">${this.renderBackground()} ${this.renderBlackOverlay()} ${this.renderOverlayDecorations()} ${this.renderContent()}</div>`;
    }
}
FullImageVideoBanner.styles = css_248z;
__decorate([
    e({ type: String })
], FullImageVideoBanner.prototype, "backgroundType", void 0);
__decorate([
    e({ type: String })
], FullImageVideoBanner.prototype, "backgroundVideoUrl", void 0);
__decorate([
    e({ type: String })
], FullImageVideoBanner.prototype, "backgroundImgUrl", void 0);
__decorate([
    e({ type: String })
], FullImageVideoBanner.prototype, "backgroundImgUrlMobile", void 0);
__decorate([
    e({ type: String })
], FullImageVideoBanner.prototype, "backgroundImgAlt", void 0);
__decorate([
    e({ type: String })
], FullImageVideoBanner.prototype, "imgUrl", void 0);
__decorate([
    e({ type: String })
], FullImageVideoBanner.prototype, "imgAlt", void 0);
__decorate([
    e({ type: String })
], FullImageVideoBanner.prototype, "title", void 0);
__decorate([
    e({ type: String })
], FullImageVideoBanner.prototype, "description", void 0);
__decorate([
    e({ type: Boolean })
], FullImageVideoBanner.prototype, "withBlackOverlay", void 0);
__decorate([
    e({ type: Boolean })
], FullImageVideoBanner.prototype, "withOverlayDecorations", void 0);
customElements.define('full-image-video-banner', FullImageVideoBanner);

export { FullImageVideoBanner };
